import React from 'react';
import ToggleContext from './ToggleContext';
function ToggleOff(_a) {
    var children = _a.children;
    return (React.createElement(ToggleContext.Consumer, null, function (_a) {
        var isOn = _a.isOn;
        return (isOn ? null : children);
    }));
}
export default ToggleOff;
